

export function shouldAllowPromoForCountry(countryCode){
    return true;
    // return countryCode === 'USA';
}